var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHandle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 22,
  viewBox: "0 0 35 22",
  fill: "none",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.60794 13.0597C-0.198093 12.532 -0.198087 9.97357 1.60795 9.4459L31.6148 0.678779C32.8198 0.326727 34.0252 1.23036 34.0252 2.48569V20.0199C34.0252 21.2753 32.8198 22.1789 31.6148 21.8268L1.60794 13.0597Z",
  fill: "white"
})));
export default SvgHandle;